/**
 * Converts numerc day value to a string
 */
export const convertIntToDay = day => {
  switch (day) {
    case 0:
      return 'Sunday'
    case 1:
      return 'Monday'
    case 2:
      return 'Tuesday'
    case 3:
      return 'Wednesday'
    case 4:
      return 'Thursday'
    case 5:
      return 'Friday'
    case 6:
      return 'Saturday'
  }
}

/**
 * Converts a day string to a numeric representation
 */
function convertDayToInt(day) {
  switch (day) {
    case 'Monday':
      return 0
    case 'Tuesday':
      return 1
    case 'Wednesday':
      return 2
    case 'Thursday':
      return 3
    case 'Friday':
      return 4
    case 'Saturday':
      return 5
    case 'Sunday':
      return 6
  }
}

/**
 * Compares Monday, Tuesday, Wednesday, etc
 */
export const compareDay = (a, b) => {
  if (typeof a == 'string' || typeof b == 'string') {
    var aInt = convertDayToInt(a),
      bInt = convertDayToInt(b)
  } else {
    var aInt = a,
      bInt = b
  }

  if (aInt < bInt) return -1
  else if (aInt === bInt) return 0
  else return 1
}

/**
 * Sorts the times items in order
 */
export const sortTimesItems = (a, b) => {
  var dayCompare = compareDay(a.day, b.day)
  if (dayCompare === 0) {
    if (a.timeStart < b.timeStart) return -1
    else if (a.timeStart === b.timeStart) return 0
    else return 1
  }
  return dayCompare
}
